// extracted by mini-css-extract-plugin
module.exports = {"lbsThinkColor":"Content2019Page_lbsThinkColor__jN1VX"};